var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/arrow-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.43 13.8201C12.24 13.8201 12.05 13.7501 11.9 13.6001C11.61 13.3101 11.61 12.8301 11.9 12.5401L17.44 7.00012L11.9 1.46012C11.61 1.17012 11.61 0.690117 11.9 0.400117C12.19 0.110117 12.67 0.110117 12.96 0.400117L19.03 6.47012C19.32 6.76012 19.32 7.24012 19.03 7.53012L12.96 13.6001C12.81 13.7501 12.62 13.8201 12.43 13.8201Z",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.33 7.75012H1.5C1.09 7.75012 0.75 7.41012 0.75 7.00012C0.75 6.59012 1.09 6.25012 1.5 6.25012H18.33C18.74 6.25012 19.08 6.59012 19.08 7.00012C19.08 7.41012 18.74 7.75012 18.33 7.75012Z",
    fill: "#292D32"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.bb0380fdd123f621d8eb9790b98a7989.svg";
export { ForwardRef as ReactComponent };